import { useQuery, useQueryClient, useMutation } from "react-query";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";

export function useContactDetails(id) {
  const queryClient = useQueryClient();
  const { isLoading, isError, isPreviousData, data, error } = useQuery(
    `/contacts/${id}`,
    {
      keepPreviousData: true,
    }
  );

  const saveContactMutation = useMutation(
    (contact) =>
      makeAuthedRequest("/contacts", {
        method: "put",
        body: JSON.stringify({
          id: contact.id,
          name: contact.name,
          email: contact.email,
          phone: contact.phone,
          type: contact.type,
        }),
      }).then(async (res) => {
        if (!res.ok) {
          const json = await res.json();

          if (json.errors && json.errors.length > 0) {
            throw new Error(json.errors[0].message);
          }
        }
      }),
    {
      onSettled: () => {
        // Invalidate all contacts data including specific contacts.
        queryClient.invalidateQueries("/contacts");
        queryClient.invalidateQueries(`/contacts/${id}`);
      },
    }
  );

  const archiveContactMutation = useMutation(
    (id) => makeAuthedRequest(`/contacts/archive/${id}`, { method: "put" }),
    {
      onSettled: () => {
        queryClient.invalidateQueries("/contacts");
        queryClient.invalidateQueries(`/contacts/${id}`);
      },
    }
  );

  const unarchiveContactMutation = useMutation(
    (id) => makeAuthedRequest(`/contacts/archive/${id}`, { method: "delete" }),
    {
      onSettled: () => {
        queryClient.invalidateQueries("/contacts");
        queryClient.invalidateQueries(`/contacts/${id}`);
      },
    }
  );

  return {
    contact: data && data.contact,
    error,
    isLoading,
    isError,
    isPreviousData,
    saveContactMutation,
    archiveContactMutation,
    unarchiveContactMutation,
  };
}
